module.exports = __webpack_public_path__ + "media/tags/smartsearch/close-icon-6be066facd90fa378ba36b600608e94a.png";